import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { PdfExportButton } from '../common/refButtons';
import { isNullOrUndefined, isEmpty } from '../../store/storeFunctions';
import { industryAnalysisActions, IA_TYPES } from '../../store/industryAnalysisStore';
import MainHeader from './mainHeader';

import './headersCommon.scss'

class IndustryAnalysisHeader extends React.Component {
    render() {
        const isOnSearchPage = this.endsWith(this.props.location.pathname, '/industry-analysis');

        return (
            <>
                <MainHeader label="IndustryAnalysis.SectionName" {...this.props} />
                {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', {'tinted' :this.props.tinted })}>
                    <ul style={{ border: "none" }}>
                        <li className={`tab-link ${isOnSearchPage ? 'is-active' : ''}`}>
                            <NavLink to={`${this.props.match.url}`} >
                                <Translate id='Search.Common.Show' />
                            </NavLink>
                            <div className="search-progress-short" style={{ display: isOnSearchPage ? "" : "none" }}></div>
                        </li>
                        <li className={`tab-link ${this.isOnResultsPage() ? 'is-active' : ''}`}>
                            <NavLink to={`${this.props.match.url}/results`}>
                                <Translate id='Search.Common.Outputs' />
                            </NavLink>
                            <div className="search-progress-short" style={{ display: this.isOnResultsPage() ? "" : "none" }}></div>
                        </li>
                    </ul>
                    {!this.props.isMobile && this.isOnResultsPage() && this.renderPdfExport()}
                </div>}
            </>
        );
    }

    renderPdfExport = () => {
        if (isNullOrUndefined(this.props.search.data))
            return null;

        if (this.props.search.type === IA_TYPES.financialRatios && isEmpty(this.props.search.data.body))
            return null;

        if (this.props.search.type === IA_TYPES.structuralIndicators && isEmpty(this.props.search.data.assets) &&
            isEmpty(this.props.search.data.liabilities) && isEmpty(this.props.search.data.profitAndLoss)
        )
            return null;

        const { type, year, okec } = this.props.search;
        return (
            <div className='search-pdf-export'>
                <div className='references print-hidden'>
                    <div className="ref-buttons" style={{ display: 'flex' }}>
                        <PdfExportButton onClick={() => this.props.exportToPdf(type, year, okec)} />
                    </div>
                </div>
            </div>
        );
    }

    isOnResultsPage = () => this.isActiveLink('/results');
    isActiveLink = (item) => this.props.location.pathname.indexOf(item) >= 0;
    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false
        : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;
}

export default withRouter(connect(
    state => ({ ...state, search: state.industryAnalysis }),
    dispatch => bindActionCreators(industryAnalysisActions, dispatch)
)(IndustryAnalysisHeader));